const mistakes = [
  {
    icon: "ri-calendar-close-line",
    title: "The School Calendar Passport Trap",
    description:
      "Your child's school sent the summer trip permission forms in January, and you filed them away with every intention of checking passports. Then lacrosse season started at Lakewood Ranch High, the SAT prep classes ramped up, and the spring golf tournament at Cypress Links consumed every weekend. Summer break arrived, and you pulled out the permission forms three days before the London departure — only to discover your daughter's passport expired in March. The school-organized trip, the non-refundable airfare, the group hotel bookings in Westminster — all hanging by a thread because a 5-year child passport quietly expired during the chaos of the school year.",
    fix: "Check every family passport in August before the school year begins. Set calendar reminders 6 months before each child's passport expiration. School-organized international trips require passport copies 3–4 months in advance — do not wait for the final reminder.",
  },
  {
    icon: "ri-parent-line",
    title: "The Child Passport Expiration Surprise",
    description:
      "Your son is now 11. His passport was issued when he was 6 — which means it expired last year on his 11th birthday. You just booked his first international school trip to Berlin, and the school requires a valid passport number for group airfare bookings. Child passports are only valid for 5 years, and many Lakewood Ranch parents forget this shorter timeline until the school sends its final reminder two weeks before departure.",
    fix: "Set a reminder for every child's passport expiration 6 months before it expires. Start renewal early for school trips, especially group bookings with non-refundable deposits and fixed departure dates.",
  },
  {
    icon: "ri-time-line",
    title: "The Six-Month Validity Oversight",
    description:
      "Your passport expires in September, and your St. Andrews golf trip is in July. You assume you are fine because it is still valid. But the UK requires six months of validity beyond your departure date. The group coordinator flags it when collecting passport copies, and your non-refundable package — booked through the Lakewood Ranch Golf and Country Club travel committee — is at risk.",
    fix: "Renew if your passport expires within 6–9 months of any international trip. Golf group packages, polo tournament bookings, and school-organized travel are typically non-refundable within 60–90 days of departure.",
  },
  {
    icon: "ri-image-line",
    title: "The Wrong Photo",
    description:
      "You took a passport photo at the pharmacy on State Road 70 using a decorative background because it looked nice. Or your child was smiling because the photographer said \"cheese.\" Or your glasses left a shadow. The State Department rejects the photo, and your application is delayed by 2–3 weeks while you resubmit. For a school trip to Paris that cost $4,800 and departs in three weeks, that delay means missing the group entirely.",
    fix: "Follow State Department photo guidelines exactly: white/off-white background, neutral expression, no glasses, correct size (2×2 inches). We review your photo before submission to eliminate rejections.",
  },
  {
    icon: "ri-file-damage-line",
    title: "The Damaged Passport",
    description:
      "Your passport went through a beach weekend at Siesta Key, got damp in a golf bag, or the binding came loose from years of Florida humidity in your Lakewood Ranch home. You think it is still usable because the data page is readable. The airline at SRQ or the cruise terminal in Tampa disagrees, and you are denied boarding.",
    fix: "Any physical damage, water damage, or unauthorized markings make a passport invalid. Replace it immediately through expedited service before any international travel.",
  },
  {
    icon: "ri-draft-line",
    title: "The Form Error",
    description:
      "You filled out the DS-11 or DS-82 form online, printed it, and signed it. But you used blue ink instead of black, signed outside the box, or left a required field blank. The acceptance clerk catches it, or worse, the State Department rejects the application after weeks of processing — right before your polo tournament in Argentina or your school trip departure.",
    fix: "Use black ink only, sign within the box boundaries, and double-check every field. We pre-review all forms before submission to eliminate this risk entirely.",
  },
];

export default function LakewoodRanchMistakesSection() {
  return (
    <section className="py-16 md:py-20 bg-[#F8F9FB]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-[#B22222] text-xs font-bold uppercase tracking-[0.15em] mb-3">
            Avoid These Mistakes
          </span>
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Common Passport Mistakes Lakewood Ranch Travelers Make
          </h2>
          <p className="text-gray-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            These are the errors we see most often from Lakewood Ranch travelers. Each one can cost you a school trip, a golf pilgrimage, a polo season, or weeks of stress.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {mistakes.map((m, i) => (
            <div
              key={i}
              className="bg-white rounded-lg p-6 border border-gray-100 hover:border-[#F6C344]/50 transition-all"
            >
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-[#B22222]/10 flex items-center justify-center shrink-0">
                  <i className={`${m.icon} text-[#B22222] text-lg`}></i>
                </div>
                <div>
                  <h3 className="font-serif text-base font-bold text-[#1A365D] mb-2">{m.title}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed mb-3">{m.description}</p>
                  <div className="bg-[#F8F9FB] rounded-md p-3">
                    <p className="text-emerald-700 text-xs font-semibold mb-0.5">
                      <i className="ri-check-line mr-1"></i>How to avoid it:
                    </p>
                    <p className="text-gray-600 text-xs leading-relaxed">{m.fix}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}